import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import {useOutlet} from 'reconnect.js';
import * as AppActions from '../../AppActions';

function Store(props) {
  const [dimension] = useOutlet('dimension');
  const [about] = useOutlet('about');
  return (
    <Wrapper rwd={dimension.rwd}>
      <div className="content">
        <div className="left">
          <h2>{AppActions.L('store_intro')}</h2>
          <div className="text">{AppActions.F(about, 'store_description')}</div>
        </div>
        <div style={{width: 20, height: 20}} />
        <div className="right">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.960775520049!2d121.54752257543032!3d25.03540517781548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abce7474ee7f%3A0xa602be16a8b3bcde!2zU0VBU09OIEFydGlzYW4gUMOidGlzc2llcuaVpuWNl-aXl-iJpuW6lw!5e0!3m2!1szh-TW!2stw!4v1730195765449!5m2!1szh-TW!2stw"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: 100vh;
  padding: ${(props) =>
    props.rwd === 'mobile'
      ? `calc(var(--topNavBarHeight) + 22px) 20px 40px 20px`
      : `calc(var(--topNavBarHeight) + 140px) 50px 40px 50px`};

  & > .content {
    margin: 0 auto;
    max-width: var(--contentMaxWidth);
    width: 100%;
    display: ${(props) => (props.rwd === 'mobile' ? 'block' : 'flex')};

    & > .left {
      flex: 3;
    }
    & > .right {
      flex: 2;
      display: flex;
      justify-content: flex-end;

      & > iframe {
        max-width: 300px;
        width: 100%;
        height: 300px;
        border: solid 1px var(--table-border-color);
      }
    }

    & h2 {
      border-bottom: solid 1px var(--table-border-color);
      font-weight: 300;
      color: var(--text-4-color);
      padding-bottom: 12px;
      margin-bottom: 12px;
    }

    & .text {
      white-space: pre-line;
      line-height: 2;
      font-weight: 300;
      color: var(--text-4-color);
    }
  }
`;

export default withPageEntry(Store);
